/* eslint-disable no-unused-vars */
import { ReviewSection } from '@/components/route_stepper/types';
import { JobPostMutationInput } from '../../../store/modules/job/types';

export enum ScheduleTypes {
  REGULAR = 'regular',
  ONE_TIME = 'one-time',
  OCCASIONAL = 'occasional',
  NANNY = 'nanny',
}

export interface JobPostDraft extends JobPostMutationInput {
  zipCode?: string;
  isPrepopulatedFromReservation?: boolean;
  scheduleType?: ScheduleTypes | null;
  headlineReviewSection?: ReviewSection;
  jobPostReturnPath?: string | null;
}
